import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Slider from './Slider';
import PracticeAreas from './PracticeAreas';
import AboutUs from './AboutUs';
import OurTeam from './OurTeam';
import News from './News';
import Video from './Video';
import ServiceIndustry from './ServiceIndustry';
class Home extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/');
}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <Spinner/>
          <TopMenu title="Bylaws"/>
          <Slider/>
          <AboutUs/>
          <PracticeAreas/>
          <ServiceIndustry/>
          <OurTeam/>
          {/*<Video/>*/}
          <Footer />
        </div>
    );
  }
}

export default Home;
